// removed by extract-text-webpack-plugin
module.exports = {"users":"_1icwzIeH7qUQsgHZxzWXWJ_0","body":"_1_R6MH0W4e98OhYM12xoLL_0","block":"_1JPLQI0dr20SJEV2tdDew6_0","short":"_186ZtPN81sBMmdcvzaS4Sl_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c4dc912a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Users/index.vue
// module id = msf9
// module chunks = 1